import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const cards = [
  {
    title: "Too Many Choices",
    description:
      "Too many resources can overwhelm even the most passionate reader.",
    image: "../media/writing.jpg",
    alt: "Illustration of scattered app icons symbolizing tool overload and lack of focus.",
  },
  {
    title: "Zero Cultural Context",
    description:
      "Readers often encounter works without knowing the author, era, or significance.",
    image: "../media/reading.jpg",
    alt: "Illustration showing confusing decision labels like 'Marketing', 'Growth', and 'Product', representing lack of priorities.",
  },
  {
    title: "No Insightful Summaries",
    description:
      "Long texts can discourage casual exploration or limit comprehension.",
    image: "../media/analysing.jpg",
    alt: "Illustration of a broken or unclear progress graph with question mark, symbolizing lost momentum and unclear progress.",
  },
];

export default function SecondSection() {
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: false,
    });
  }, []);

  return (
    <section style={{ padding: "50px 0", textAlign: "center" }}>
      {/* Heading */}
      <div style={{ marginBottom: "40px" }} data-aos="fade-up">
        <div
          style={{
            color: "#6c757d",
            fontWeight: 600,
            marginBottom: "10px",
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          Problem
        </div>
        <h2 style={{ fontSize: "2rem", marginBottom: "15px", lineHeight: 1.3 }}>
          Why readers miss global literature
        </h2>
        <p
          style={{
            color: "#6c757d",
            maxWidth: "600px",
            margin: "0 auto",
            lineHeight: 1.6,
          }}
        >
          Many works remain hidden behind language barriers, overwhelming
          databases, or dense academic reviews. Biblivium makes discovery
          simple and elegant.
        </p>
      </div>

      {/* Cards */}
      <div className="container">
      <div className="row">
        {cards.map((card, index) => (
          <div
            key={index}
            className="col-md-4 d-flex justify-content-center mb-4"
            data-aos="zoom-in"
            data-aos-delay={index * 120}
          >
            <div
              style={{
                border: "1px solid #dee2e6",
                borderRadius: "10px",
                padding: "20px",
                textAlign: "center",
                transition: "transform 0.3s, box-shadow 0.3s",
                // maxWidth: "320px",
                width: "100%",
                cursor: "pointer",
              }}
              className="card-hover"
            >
              <img
                src={card.image}
                alt={card.alt}
                style={{
                  width: "100%",
                  height: "auto",
                  marginBottom: "15px",
                  borderRadius: "8px",
                }}
              />
              <h4 style={{ marginBottom: "10px" }}>{card.title}</h4>
              <p style={{ color: "#6c757d", lineHeight: 1.5 }}>
                {card.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      </div>

      {/* Solution */}
      <div
        style={{
          marginTop: "40px",
          fontWeight: 500,
          color: "#343a40",
          fontSize: "1.1rem",
          lineHeight: 1.6,
          maxWidth: "700px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
        data-aos="fade-up"
        data-aos-delay="400"
      >
        With Biblivium, readers can explore curated global literature with
        clarity, context, and elegance.
      </div>

      {/* Hover effect */}
      <style>{`
        .card-hover:hover {
          transform: translateY(-6px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.1);
        }
      `}</style>
    </section>
  );
}
